import sortBy from 'lodash/sortBy';

import { IBusinessUnitModel } from '@crm-package/dictionaries';

export const getBusinessUnitsSortByNameHelper = (
  businessUnits: readonly IBusinessUnitModel[]
): IBusinessUnitModel[] =>
  sortBy(businessUnits, (businessUnit) => businessUnit.name.toLowerCase());
